import firebase from 'gatsby-plugin-firebase';

const deleteResume = async (id: string): Promise<void> => {
  await firebase.database().ref(`/resumes/${id}`).remove();
};

export default deleteResume;
